import { ApiClientStatus } from 'hellospa/redux/types';
import { MoarNamespaceState, Actions, MoarAction } from './types';


const tierPages = [
  5,
  10,
  25,
  50,
  100,
  200,
];

export const defaultState: MoarNamespaceState = {
  result: null,
  recipient: '',
  hasErrored: false,
  tier: 0,
  pages: tierPages[0],
  resetKey: Math.random(),
};

export function moarReducer(
  state: MoarNamespaceState = defaultState,
  action: MoarAction,
): MoarNamespaceState {

  switch (action.type) {
    case Actions.Reset:
      if (action.payload.resetAll) {
        return defaultState;
      }

      return {
        ...state,
        result: null,
        resetKey: Math.random(),
      };
    case Actions.Recipient:
      return {
        ...state,
        recipient: action.payload,
      };
    case Actions.GrantFetch:
      return {
        ...state,
        result: {
          apiStatus: ApiClientStatus.Fetch,
        },
      };
    case Actions.GrantSuccess:
      return {
        ...state,
        result: {
          apiStatus: ApiClientStatus.Success,
          pages: action.payload.pages,
          recipient: action.payload.recipient,
        },
      };
    case Actions.GrantError:
      return {
        ...state,
        hasErrored: true,
        result: {
          apiStatus: ApiClientStatus.Error,
          message: action.error,
        },
      };
    case Actions.Increment: {
      const tier = ((state.tier + 1) + tierPages.length) % tierPages.length;
      const pages = tierPages[tier];
      return {
        ...state,
        tier,
        pages,
      };
    }
    case Actions.Decrement: {
      const tier = ((state.tier - 1) + tierPages.length) % tierPages.length;
      const pages = tierPages[tier];
      return {
        ...state,
        tier,
        pages,
      };
    }
    default:
      return state;
  }
}
